import React, { Component } from "react";
import { withFormik, Form, Field } from "formik";
import { connect } from "react-redux";
import * as actions from "../actions";
import * as Yup from "yup";
import { INPUT_FIELDS } from "./add_notes_fields";
import { FormTitle, FormButtons } from "components/form";

class AddNotesAppointmentForm extends Component {
  renderFields = () => {
    const { viewMode, editMode, values } = this.props;
    return INPUT_FIELDS.map((field, i) => {
      return (
        <Field
          key={i}
          viewMode={viewMode}
          editMode={editMode}
          values={values}
          {...field}
        />
      );
    });
  };

  render() {
    const {
      errors,
      dirty,
      isSubmitting,
      editMode,
      viewMode,
      cancel,
      defaultRoute,
    } = this.props;
    return (
      <div>
        <Form>
          <FormTitle group={"appointmentsAddNotes"} />
          <br />
          {this.renderFields()}
          <br />
          <FormButtons
            viewMode={viewMode}
            editMode={editMode}
            isSubmitting={isSubmitting}
            errors={errors}
            dirty={dirty}
            cancel={cancel}
            linkTo={defaultRoute}
          />
          <br />
        </Form>
      </div>
    );
  }
}

AddNotesAppointmentForm = withFormik({
  mapPropsToValues({ valuesToEdit }) {
    return {
      userNotes: valuesToEdit.userNotes || "",
      _id: valuesToEdit._id,
    };
  },
  validationSchema: Yup.object().shape({
    userNotes: Yup.string().max(1000, "max-1000"),
  }),
  handleSubmit(values, { props, setSubmitting }) {
    if (props.editMode) {
      return props.updateAppointmentsEntry(values, setSubmitting);
    }
  },
})(AddNotesAppointmentForm);

export default connect(null, actions)(AddNotesAppointmentForm);
